import tools from '@/sag-core/tools'
import StoreBase from '@/sag-core/base/StoreBase'
export default function Store(serviceName){
    return tools.mergeDeep(
        new StoreBase(serviceName), {})
}


